import { TextField } from "@mui/material";
import type { KeyboardEventHandler } from "react";
import { useFormsContext } from "../../context/FormsContext";
import { useDebounce } from "use-debounce";
import { useEffect, useState, useRef } from "react";

type Props = {
	onKeyDown: KeyboardEventHandler<HTMLDivElement> | undefined;
};

export const SearchFilter = ({ onKeyDown }: Props) => {
	const {
		state: { searchText },
		actions: { setSearchText },
	} = useFormsContext();

	const [localSearchText, setLocalSearchText] = useState(searchText);
	const [debouncedSearchText] = useDebounce(localSearchText, 400);
	const isFirstRender = useRef(true);

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			return;
		}
		setLocalSearchText(searchText);
	}, [searchText]);

	useEffect(() => {
		if (debouncedSearchText !== searchText) {
			setSearchText(debouncedSearchText);
		}
	}, [debouncedSearchText]);

	const onTextChange = (e: any) => {
		setLocalSearchText(e.target.value);
	};

	return (
		<div style={{ position: "relative" }}>
			<TextField
				label="Form name to search"
				variant="outlined"
				margin="dense"
				onKeyDown={onKeyDown}
				value={localSearchText}
				onChange={onTextChange}
				fullWidth
				autoComplete="off"
			/>
			<i
				className="fa fa-search"
				style={{
					position: "absolute",
					right: 17,
					top: 20,
					cursor: "pointer",
				}}
			/>
		</div>
	);
};
